const MOLE_FILES_BASE =
  "https://dpmxc8w94tjf5.cloudfront.net/mole-files";

export const POLICY_DOCUMENTS = {
  CONSENT: `${MOLE_FILES_BASE}/riza_metni_kvkk.pdf`,
  MEMBERSHIP: `${MOLE_FILES_BASE}/uyelik_sozlesmesi.pdf`,
  COOKIE:
    "https://mole-s3.s3.eu-central-1.amazonaws.com/mole-files/cerez.pdf",
};

export const POLICY_LINK_CLASS_NAME =
  "underline font-medium text-kostebek-600";
